export default "__VITE_ASSET__f6d17ddd__"